import 'reflect-metadata';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';
import { AppErrorBoundary, initSentry } from '../helpers/sentryHelpers';
import App from '../topLevel/App';
import { HelixThemeProvider } from '@helix/theming';
import { ToastProvider } from '@helix/toasts';

initSentry();

ReactDOM.render(
    <AppErrorBoundary>
        <HelixThemeProvider>
            <ToastProvider position='top-left'>
                <App />
            </ToastProvider>
        </HelixThemeProvider>
    </AppErrorBoundary>,
    document.getElementById('boost-everywhere-root')
);

// @ts-ignore
if (module.hot) {
    // @ts-ignore
    module.hot.accept();
}
